<template>
<div class="bank-setting padding-20 bgc box-shadow">
    <div class="top_handle_box">
        <div class="return-exam-list" @click="handleReturnExamList">返回考试列表</div>
        <div>
            <div style="width: 150px;">
                <el-select v-model="subjectcode" placeholder="科目名称" clearable>
                    <el-option v-for="item in subjectList" :key="item.subjectcode" :label="item.subjectname" :value="item.subjectcode"></el-option>
                </el-select>
            </div>
            <div style="width: 150px;">
                <el-select v-model="sectioncode" placeholder="版块名称" clearable>
                    <el-option v-for="item in sectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <el-button @click="handleGetQuestionbankTopicQBList" type="primary" plain>搜索</el-button>
        </div>
    </div>
    <div class="btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="序号" width="80px" align="center">
                <template slot-scope="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column label="考试名称" min-width="120px" prop="examname" show-overflow-tooltip></el-table-column>
            <el-table-column label="科目名称" min-width="120px" prop="subjectname" show-overflow-tooltip></el-table-column>
            <el-table-column label="版块名称" width="110px" prop="sectionname" show-overflow-tooltip></el-table-column>
            <el-table-column label="对应题库ID" width="160px" prop="qbcode" show-overflow-tooltip></el-table-column>
            <el-table-column label="对应题库" min-width="180px" prop="qbname" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="150px" align="right">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn" v-if="scope.row.sectioncode === '0101'">
                            <el-button @click.stop="handleChange(scope.row)" type="text" size="small">更换</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleCheck(scope.row)" type="text" size="small">查看</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleDelete(scope.row, scope.$index)" type="text" size="small">删除</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <SpecialChangeQbDialog ref="specialChangeQbDialog" @handleChangeSuccess="handleGetQuestionbankTopicQBList"></SpecialChangeQbDialog>
</div>
</template>
<script>
import {mapActions} from 'vuex'
import SpecialBank from '@/common/js/specialBank.json'
import {getQuestionbankTopicQBList, deleteQuestionbankTopicQB} from '@/api/questionApi.js'
import SpecialChangeQbDialog from './components/specialChangeQbDialog.vue'
export default {
    name: 'BankSetting',
    data() {
        return {
            subjectcode: '',
            subjectList: [],
            sectioncode: '',
            sectionList: [
                {label: '每日一练', value: '0100'},
                {label: '章节练习', value: '0101'},
                {label: '历年真题', value: '0102'},
                {label: '模拟试题', value: '0103'}
            ],
            tableData: []
        }
    },
    created() {
        if (this.$route.query.examcode) {
            this.subjectList = SpecialBank[this.$route.query.examcode].children
            this.handleGetQuestionbankTopicQBList()
        }
    },
    methods: {
        handleReturnExamList() {
            this.$router.go(-1)
        },
        handleGetQuestionbankTopicQBList() {
            this.setLoading(true)
            getQuestionbankTopicQBList({
                data: {
                    examcode: this.$route.query.examcode,
                    sectioncode: this.sectioncode,
                    subjectcode: this.subjectcode
                },
                success: data => {
                    this.tableData = data.data
                    this.setLoading(false)
                },
                error: error => {
                    this.setLoading(false)
                    this.$message.error(error.msg)
                }
            })
        },
        // 更换
        handleChange(row) {
            this.$refs.specialChangeQbDialog.handleOpen(row.configcode)
        },
        // 查看
        handleCheck(row) {
            if (row.sectioncode=== '0101') {
                this.$router.push({
                    name: 'SubjectChapterSetUp',
                    query: {
                        qid: row.qbcode
                    }
                })
            } else {
                this.$router.push({
                    name: 'TestpaperQuesEdit',
                    query: {
                        id: row.exampaperinnerid
                    }
                })
            }
        },
        // 删除
        handleDelete(row, index) {
            this.$confirm('确认删除该考试吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                deleteQuestionbankTopicQB({
                    data: {
                        configcode: row.configcode,
                        qbcode: row.qbcode
                    },
                    success: data => {
                        this.tableData.splice(index, 1)
                        this.$message.success(error.msg)
                        this.setLoading(false)
                    },
                    error: error => {
                        this.setLoading(false)
                        this.$message.error(error.msg)
                    }
                })
            }).catch(() => {    
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        SpecialChangeQbDialog
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
.bank-setting {
    .top_handle_box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .return-exam-list {
            color: #409EFF;
            cursor: pointer;
        }
        &>div:nth-of-type(2){
            display: flex;
            .el-input__icon {
                line-height: 0px;
            }
            &>div {
                margin-right: 20px;
            }
        }
    }
    .table_handle_box {
        span{
            color: #439FFE;
            cursor: pointer;
            font-size: 12px;
        }
        .span_text:hover{
            color: rgb(8, 125, 243);
        }
    }
}
</style>